/**
 * 사이드바 유틸 함수
 * 원본 SidebarMenuCommon의 함수들을 React에서 사용할 수 있도록 변환
 */

/**
 * HTML 이스케이프
 */
export const escapeHtml = (text) => {
  if (!text) return '';
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };
  return String(text).replace(/[&<>"']/g, (m) => map[m]);
};

/**
 * Href 이스케이프
 */
export const escapeHref = (href) => {
  if (!href) return '';
  return String(href).replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
};

/**
 * 유효한 href인지 확인
 */
export const isValidHref = (href) => {
  return href && typeof href === 'string' && href.trim() !== '' && href !== '#';
};

/**
 * 내부 링크인지 확인 (React Router 사용)
 */
export const isInternalLink = (href) => {
  if (!isValidHref(href)) return false;
  return href.startsWith('/') && !href.startsWith('//');
};

